import React from "react";
import "./header.css";
import { FaUserAlt } from "react-icons/fa";
import { IoIosLogOut, IoMdSettings } from "react-icons/io";
import { MdOutlineNotifications } from "react-icons/md";

const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-4 shadow-sm">
      <span className="navbar-brand fw-semibold">
        <i className="bi bi-building-gear me-2"></i>
        HRMS
      </span>

      <div className="ms-auto d-flex align-items-center gap-3">
        <i className="bi bi-bell fs-5 text-white"></i>
        <div className="d-flex align-items-center text-white">
          <i className="bi bi-person-circle fs-4 me-2"></i>
          Admin
        </div>
      </div>
    </nav>
  );
};

export default Header;
